import React, { useEffect, useState } from 'react';
import '../Billing.css';
import {
    Divider,
    InputNumber,
    Select,
    Modal,
    Row,
    Col,
    Form,
    Input,
    Button,
    message,
} from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { ProductsActionHandler } from '../../../../Redux/Actions/user/ProductsList';
import {
    ProductsPlanActionHandler,
    ProductsPlanSuccess,
} from '../../../../Redux/Actions/user/ProductsPlan';
import { workspaces_List_ActionHandler } from '../../../../Redux/Actions/user/WorkspacesList';
import Loader from '../../../../Components/Loader/Loader';
import { Link } from 'react-router-dom';
const { Option } = Select;
const Plans = () => {
    let dispatch = useDispatch();
    const [form] = Form.useForm();
    const [quantities, setQuantities] = useState({});
    const [productsplanDatapayment, setproductsplanDatapayment] =
        useState(null);
    const productsData = useSelector(
        (state) => state?.ProductsData?.products_data?.data
    );
    const productsplanData = useSelector(
        (state) => state?.ProductsPlanData?.products_plan_data?.data
    );
    const workspaceData = useSelector(
        (state) => state?.workspaces_List_Data?.workspace_create_data?.data
    );
    const [open, setOpen] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [pid, setPid] = useState('');
    const [wid, setWid] = useState('');
    const [coupon, setCoupon] = useState('');
    const showModal = () => {
        setOpen(true);
    };
    const userDetails = JSON.parse(localStorage.getItem('userDetails'));
    const handleOk = () => {
        setConfirmLoading(true);
        setOpen(false);
        setConfirmLoading(false);
    };
    const PurchaseshowModal = (id) => {
        setPid(id);
        setIsModalOpen(true);
    };
    useEffect(() => {
        if (isModalOpen) {
            form.resetFields();
        }
    }, [isModalOpen, form]);
    const PurchasehandleCancel = () => {
        setCoupon('');
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setOpen(false);
    };
    const fetchData = async () => {
        try {
            dispatch(ProductsActionHandler());
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const handlePlan = (productId) => {
        const matchingProduct = productsData?.find(
            (product) => product?.id === productId
        );
        if (matchingProduct?.meta_data?.require_workspace_id === '1') {
            if (!wid) {
                message.error('please select the workspace!');
                return;
            }
        }

        setPid(productId);
        const { workspaceId, quantity } = quantities[productId];
        dispatch(
            ProductsPlanActionHandler(
                productId,
                quantity || 1,
                workspaceId || null,
                coupon
            )
        );
    };
    const onFinish = (values) => {
        setCoupon(values.coupon_code);
        const { workspaceId, quantity } = quantities[pid];
        dispatch(
            ProductsPlanActionHandler(
                pid,
                quantity || 1,
                wid || null,
                values.coupon_code
            )
        );
    };
    const onChange = (productId, quantity) => {
        setQuantities((prevQuantities) => ({
            ...prevQuantities,
            [productId]: {
                workspaceId: prevQuantities[productId]?.workspaceId,
                quantity: quantity || 1,
            },
        }));
    };
    const handleChangeWorkspace = (productId, workspaceId) => {
        setWid(workspaceId);
        setQuantities((prevQuantities) => ({
            ...prevQuantities,
            [productId]: {
                workspaceId,
                quantity: prevQuantities[productId]?.quantity,
            },
        }));
    };
    useEffect(() => {
        dispatch(ProductsPlanSuccess(null));
        return () => {
            setproductsplanDatapayment(null);
            dispatch(ProductsPlanSuccess(null));
        };
    }, []);

    useEffect(() => {
        if (productsplanData) {
            setproductsplanDatapayment(productsplanData);
        }
    }, [productsplanData]);

    useEffect(() => {
        if (productsplanDatapayment) {
            window.location = productsplanData.url;
        }
    }, [productsplanDatapayment]);

    useEffect(() => {
        if (productsData) {
            const initialQuantities = {};
            productsData.forEach((product) => {
                initialQuantities[product.id] = 1;
            });
            setQuantities(initialQuantities);
        }
    }, [productsData]);
    useEffect(() => {
        dispatch(workspaces_List_ActionHandler('', ''));
        fetchData();
    }, []);

    return (
        <div className='over-main'>
            <Row className='title-plan'>
                <Col span={24}>
                    <h1>
                        Welcome to QuickAction,{' '}
                        <span className='blue-color'>
                            {userDetails?.first_name} {userDetails?.last_name}{' '}
                        </span>
                    </h1>
                </Col>
            </Row>
            <Row className='title-plan'>
                <Col span={12}>
                    <p style={{ fontSize: '22px' }}>
                        Turn repeatable tasks into Al-powered QuickActions
                    </p>
                    <p style={{ fontSize: '18px' }}>
                        Thank you for choosing our platform. Before you get
                        started, please select a pricing plan that best fits
                        your needs:
                    </p>
                </Col>
            </Row>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <div className='credits-div credits-div-data'>
                    {productsData ? (
                        productsData &&
                        productsData.map((product, index) => (
                            <div className='starter1' key={index}>
                                <div className='button-line'>
                                    <button className='starter-btn'>
                                        {product.name}
                                    </button>
                                </div>
                                <div className='amount-div'>
                                    <p className='amount font-32bold'>
                                        £
                                        {(
                                            product.decimal_amount / 100
                                        )?.toLocaleString()}
                                    </p>
                                </div>
                                <div className='every-month'>
                                    {product.interval_count === 1 ? (
                                        <>
                                            <p>Every {product.interval} </p>
                                            <p>
                                                {/* {product.meta_data["trial"] !== undefined &&
                      product.meta_data["trial"] !== null ? (
                        <p>{product.meta_data["trial"]} day free trial</p>
                      ) : null} */}
                                            </p>
                                        </>
                                    ) : null}
                                </div>
                                <div className='trial-free'>
                                    {!product?.interval_count === 1 ? (
                                        <InputNumber
                                            min={1}
                                            max={10}
                                            defaultValue={1}
                                            className='mr-2'
                                            onChange={(value) =>
                                                onChange(product.id, value)
                                            }
                                        />
                                    ) : (
                                        <>
                                            {product.meta_data[
                                                'require_workspace_id'
                                            ] === '1' ? (
                                                <>
                                                    <Select
                                                        className='plan-select'
                                                        onChange={(value) =>
                                                            handleChangeWorkspace(
                                                                product.id,
                                                                value
                                                            )
                                                        }
                                                        placeholder='WorkSpace...'
                                                        style={{
                                                            width: '33%',
                                                        }}>
                                                        {workspaceData &&
                                                            workspaceData.map(
                                                                (workspace) => (
                                                                    <>
                                                                        {workspace.is_locked ===
                                                                        false ? (
                                                                            <Option
                                                                                key={
                                                                                    workspace.id
                                                                                }
                                                                                value={
                                                                                    workspace.id
                                                                                }>
                                                                                {
                                                                                    workspace?.name
                                                                                }
                                                                            </Option>
                                                                        ) : null}
                                                                    </>
                                                                )
                                                            )}
                                                    </Select>
                                                    <InputNumber
                                                        min={1}
                                                        max={10}
                                                        defaultValue={1}
                                                        className='mr-2'
                                                        onChange={(value) =>
                                                            onChange(
                                                                product.id,
                                                                value
                                                            )
                                                        }
                                                    />
                                                </>
                                            ) : (
                                                <>
                                                    <InputNumber
                                                        min={1}
                                                        max={10}
                                                        defaultValue={1}
                                                        className='mr-2'
                                                        onChange={(value) =>
                                                            onChange(
                                                                product.id,
                                                                value
                                                            )
                                                        }
                                                    />
                                                </>
                                            )}
                                        </>
                                    )}

                                    {product.meta_data['can_buy_directly'] ===
                                    '0' ? (
                                        <button onClick={showModal}>
                                            Contact Us
                                        </button>
                                    ) : (
                                        <>
                                            <button
                                                onClick={() =>
                                                    handlePlan(product.id)
                                                }>
                                                Purchase
                                            </button>
                                        </>
                                    )}
                                </div>
                                {product.meta_data['can_buy_directly'] ===
                                '0' ? (
                                    <p className='coupon hiddencoupen'></p>
                                ) : (
                                    <Link
                                        className='coupon'
                                        onClick={() =>
                                            PurchaseshowModal(product.id)
                                        }>
                                        Apply coupon code
                                    </Link>
                                )}

                                <Divider />

                                <div>
                                    {product?.features &&
                                        product?.features?.map(
                                            (data, index) => (
                                                <div className='points'>
                                                    <img
                                                        src='/images/tick.svg'
                                                        alt=''
                                                        style={{
                                                            height: 'fit-content',
                                                            marginTop: 8,
                                                        }}
                                                    />
                                                    <p>{data.name}</p>
                                                </div>
                                            )
                                        )}
                                </div>
                                <Modal
                                    title='Contact Us'
                                    open={open}
                                    onOk={handleOk}
                                    confirmLoading={confirmLoading}
                                    onCancel={handleCancel}>
                                    <p>
                                        Please contact{' '}
                                        <a href='mailto:support@quickaction.ai'>
                                            support@quickaction.ai
                                        </a>{' '}
                                        for more details.
                                    </p>
                                </Modal>
                            </div>
                        ))
                    ) : (
                        <Loader />
                    )}
                    <Modal
                        title=''
                        open={isModalOpen}
                        onCancel={PurchasehandleCancel}
                        footer={null}>
                        <Form
                            form={form}
                            name='coupon_code'
                            onFinish={onFinish} // Make sure this function is defined or imported in your component
                            style={{
                                maxWidth: '400px',
                                margin: 'auto',
                            }}>
                            <label>Apply Coupon Code</label>
                            <Form.Item
                                name='coupon_code'
                                rules={[
                                    {
                                        required: true,
                                        message:
                                            'Please input your coupon code!',
                                    },
                                    {
                                        type: 'text',
                                        message:
                                            'Please enter a valid coupon code',
                                    },
                                ]}>
                                <Input
                                    placeholder='Enter your coupon code'
                                    value={coupon}
                                />
                            </Form.Item>
                            <Form.Item className='btn-class'>
                                <Button
                                    type='primary'
                                    htmlType='submit'
                                    // block
                                >
                                    Apply
                                </Button>
                            </Form.Item>
                        </Form>
                    </Modal>
                </div>
            </div>
        </div>
    );
};
export default Plans;
